<div class="account-settings-page">
  <header class="account-settings-page__title-card page-card card">
    <div class="card-body">
      <h1 class="account-settings-page__title bw-title-with-info">
        Profile
        <app-info-tooltip compact placement="right" text="Update the identity and contact details used across your BizzWeaver account."></app-info-tooltip>
      </h1>
    </div>
  </header>

  @if (isInitialLoading) {
    <div class="loading-wrapper">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Loading profile...</p>
    </div>
  } @else if (hasInitialLoadError) {
    <app-api-load-error
      title="Could not load profile"
      message="Some error occurred while loading your profile. Please try again."
      retryLabel="Retry"
      (retry)="loadProfile()"
    ></app-api-load-error>
  } @else {
    <section class="page-card card">
      <div class="card-body">
        @if (profileMessage) {
          <div class="alert alert-success">{{ profileMessage }}</div>
        }
        @if (profileError) {
          <div class="alert alert-danger">{{ profileError }}</div>
        }

        <form (ngSubmit)="saveProfile()">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" [value]="profile?.email || ''" readonly />
            </div>
            <div class="col-md-6">
              <label class="form-label">Nickname</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="profileForm.nickname"
                name="profile_nickname"
                maxlength="80"
                placeholder="Public URL handle, for example paulb or studio-north"
              />
              <small class="form-text text-body-secondary">
                This nickname is used in published site URLs. It is normalized to lowercase letters, numbers, and hyphens.
              </small>
            </div>
            <div class="col-md-6">
              <label class="form-label">Full Name</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="profileForm.name"
                name="profile_name"
                maxlength="120"
                placeholder="Your full name"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">Account Created</label>
              <input type="text" class="form-control" [value]="profile?.createdAt || ''" readonly />
            </div>
            <div class="col-12">
              <div class="form-check">
                <input
                  id="product-analytics-enabled"
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="profileForm.productAnalyticsEnabled"
                  name="product_analytics_enabled"
                />
                <label class="form-check-label" for="product-analytics-enabled">
                  Share product analytics
                  <app-info-tooltip compact placement="right" text="Allow BizzWeaver to record privacy-safe product interactions, such as page views, clicks, focus changes, and time on screen. Typed values, passwords, query strings, IP addresses, browser fingerprints, and raw user agents are never recorded."></app-info-tooltip>
                </label>
                <small class="form-text text-body-secondary d-block">
                  Turning this off stops future BizzWeaver product analytics for this account. It does not delete existing aggregated activity records.
                </small>
              </div>
            </div>
          </div>

          <div class="mt-3 d-flex justify-content-end">
            <button class="btn btn-primary" type="submit" [disabled]="isSavingProfile">
              @if (!isSavingProfile) {
                <span>Save Profile</span>
              } @else {
                <span>Saving...</span>
              }
            </button>
          </div>
        </form>
      </div>
    </section>
  }
</div>
